export default "__VITE_ASSET__h$gfftm4__"